import { NoteBlock } from "../block";

export interface SubscriptionBlock extends NoteBlock {
  type: "omega/query-omega/page/block/subscription/SubscriptionBlock";
  "sub-id": string;
}

export function isSubscriptionBlock(block: NoteBlock): block is SubscriptionBlock {
  return (block as SubscriptionBlock)["sub-id"] !== undefined;
}
